module.exports = __webpack_public_path__ + "images/pinterest.7b64be431090fd52c62703e71588faf1.svg";